import React from "react";

const Contactus = () => {
  return (
    <>
      <div className="container-fluid p-4">
        <div className="container-fluid d-flex latest_card_box_ad p-0">
          <div className="contactleft map text-center">
            <iframe title="School Location Map" src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d117055.19774042016!2d77.24447911149228!3d23.53340410858005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x397c7995297d48dd%3A0x57b98165d3633a92!2sH.%20No.%2020%2C%20Khejda%20Square%2C%2066%20Feet%20Road%2C%20behind%20Think%20Gas%20Petrol%20Pump%2C%20Maholi%2C%20Bhopal%2C%20Madhya%20Pradesh%20462030!3m2!1d23.5334258!2d77.32688069999999!5e0!3m2!1sen!2sin!4v1744279946381!5m2!1sen!2sin" width="600" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div className="contactright text-left">
            <div className="titlecontact">
              <h4 className="ssss">School</h4>
              <hr />

              <p className="linkwrap">
                <b className="bbb">Phone:</b>{" "}
                <a className="linkwrap mnc" href="tel:  7610316159">
                  +91 7610316159, +91 7049346989
                </a>{" "}
              </p>
              <p className="linkwrap">
                <b className="bbb">Email:</b>{" "}
                <a
                  className="linkwrap mnc"
                  href="mailto: dedicationschool@gmail.com "
                >
                  dedicationschool@gmail.com
                </a>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contactus;
